/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { GetReelEventName, ReelEvent } from '../../Reel/ReelEvent';
import ISymbolData from '../ISymbolData';
import StreakTrackerRuleBase from './StreakTrackerRuleBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class ReelSymbolRule extends StreakTrackerRuleBase
{
    @property({ override: true, visible: false })
    protected symbolId: string = '';

    @property()
    protected addActivePayline: boolean = false;

    protected onLoad(): void
    {
        if (this.addActivePayline) { this.addActivePaylineFilter(); }

        super.onLoad();
    }

    public onRestore(): void
    {
        this.streakOnReelEvent = ReelEvent.OnLanded;
        this.OnStreakEvent = GetReelEventName(ReelEvent.OnLanded);
        this.OnClearEvent = '';
        this.shouldClear = false;
    }

    protected applyRuleFilter(): ISymbolData[]
    {
        return this.validSymbols;
    }

    /**
     * Dispatch [[StreakEvent]] to given reel [[Symbol]].
     * @param symbol [[Symbol]] to dispatch to.
     */
    protected sendOnStreakEvent = (symbol: ISymbolData): void =>
    {
        if (this.dispatchedSymbolNodes.indexOf(symbol.Node) < 0)
        {
            symbol.Node.emit(this.OnStreakEvent);
            this.dispatchedSymbolNodes.push(symbol.Node);
        }

        this.hasStreaked = true;
    }

    /**
     * Dispatch [[StreakEvent]] to clear reel [[Symbol]].
     * @param symbol [[Symbol]] to dispatch to.
     */
    protected sendOnClearEvent = (symbolNode: cc.Node): void =>
    {
        symbolNode.emit(this.OnClearEvent, true);
    }

    /**
     * Base filter for [[Symbol]] ID.
     * @param symbols [[Symbol]] information to filter on.
     * @returns valid symbols.
     */
    protected symbolMatchFilter(symbols: ISymbolData[]): ISymbolData[]
    {
        return symbols;
    }
}
